// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__sTtW7","spinner":"LoadingSpinner_spinner__jmu8Z","spin":"LoadingSpinner_spin__YPWy1"};